export default {
  "privacy": {
    "heroTitle": "سياسة الخصوصية",
    "lastUpdated": "آخر تحديث: 3 أغسطس 2026",
    "sections": [
      {
        "title": "1. مقدمة",
        "paragraphs": [
          "تلتزم IS TELECOM (المشار إليها فيما يلي بـ « نحن » أو « IS TELECOM ») بحماية خصوصية وبيانات مستخدميها وعملائها وشركائها الشخصية. تشرح سياسة الخصوصية هذه كيف نجمع ونستخدم ونخزن ونحمي بياناتكم الشخصية عند استخدامكم لموقعنا is-telecom.co (المشار إليه فيما يلي بـ « الموقع ») أو عند تفاعلكم معنا.",
          "باستخدام الموقع أو تزويدنا ببياناتكم الشخصية، فإنكم تقبلون الممارسات الموضحة في سياسة الخصوصية هذه. إذا كنتم لا تقبلون هذه السياسة، يرجى عدم استخدام الموقع."
        ]
      },
      {
        "title": "2. المسؤول عن المعالجة",
        "paragraphs": [
          "المسؤول عن معالجة البيانات الشخصية التي يتم جمعها عبر الموقع هو IS TELECOM، الكائن في كوتونو، بنين.",
          "الهاتف: +229 01 95 89 27 55 — البريد الإلكتروني: contact@is-telecom.co"
        ]
      },
      {
        "title": "3. البيانات المجمعة",
        "paragraphs": ["نجمع الفئات التالية من البيانات الشخصية:"],
        "list": [
          "بيانات التعريف: الاسم واللقب واسم الشركة",
          "بيانات الاتصال: عنوان البريد الإلكتروني ورقم الهاتف والعنوان البريدي",
          "بيانات المشروع: نوع المشروع والموقع والميزانية المقدرة ووصف الاحتياجات",
          "بيانات التصفح: عنوان IP ونوع المتصفح والصفحات التي تمت زيارتها ومدة الزيارة"
        ]
      },
      {
        "title": "4. أغراض المعالجة",
        "paragraphs": ["يتم جمع بياناتكم الشخصية ومعالجتها للأغراض التالية:"],
        "list": [
          "الرد على الطلبات: معالجة طلبات عروض الأسعار والاتصال والمعلومات",
          "إدارة علاقة العملاء: متابعة مشاريعكم وإعداد عروض الأسعار وإدارة العقود",
          "التواصل: إعلامكم بخدماتنا وأخبارنا وعروضنا (بموافقتكم)",
          "تحسين الموقع: تحليل استخدام الموقع لتحسين المحتوى والتنقل",
          "الالتزامات القانونية: الامتثال لالتزاماتنا القانونية والتنظيمية والضريبية"
        ]
      },
      {
        "title": "5. الأساس القانوني للمعالجة",
        "paragraphs": ["تستند معالجة بياناتكم الشخصية إلى أحد الأسس القانونية التالية:"],
        "list": [
          "تنفيذ عقد: عندما تكون المعالجة ضرورية لتنفيذ عقد",
          "الموافقة: عندما تكونون قد أعطيتم موافقتكم الصريحة",
          "المصلحة المشروعة: عندما تكون المعالجة ضرورية للمصالح المشروعة لـ IS TELECOM",
          "الالتزام القانوني: عندما تكون المعالجة ضرورية للامتثال لالتزام قانوني"
        ]
      },
      {
        "title": "6. مدة الاحتفاظ",
        "paragraphs": ["يتم الاحتفاظ ببياناتكم الشخصية للمدة الضرورية للغاية:"],
        "list": [
          "طلبات الاتصال/عروض الأسعار: 3 سنوات من آخر اتصال",
          "بيانات العملاء والعقود: 10 سنوات من نهاية العقد",
          "النشرة الإخبارية والتسويق: حتى تسحبوا موافقتكم",
          "بيانات التصفح (ملفات تعريف الارتباط): 13 شهرًا كحد أقصى"
        ]
      },
      {
        "title": "7. مشاركة البيانات",
        "paragraphs": [
          "لا تبيع IS TELECOM ولا تؤجر بياناتكم الشخصية لأطراف ثالثة. ومع ذلك، قد تتم مشاركة بياناتكم مع مقدمي الخدمات (استضافة الويب، أدوات التحليل، خدمات البريد)، والسلطات المختصة عندما يقتضي القانون ذلك، أو الشركاء التجاريين فقط بموافقتكم المسبقة."
        ]
      },
      {
        "title": "8. أمن البيانات",
        "paragraphs": [
          "تطبق IS TELECOM تدابير تقنية وتنظيمية مناسبة لحماية بياناتكم الشخصية: تشفير البيانات أثناء النقل (HTTPS/TLS)، والوصول المقيد حسب الأدوار، وتدريب الموظفين، والمراقبة والتدقيق المنتظمين."
        ]
      },
      {
        "title": "9. حقوقكم",
        "paragraphs": [
          "وفقًا للتشريعات المعمول بها، تتمتعون بالحقوق التالية: حق الوصول، وحق التصحيح، وحق المحو، وحق التقييد، وحق الاعتراض، وحق نقل البيانات."
        ]
      },
      {
        "title": "10. ملفات تعريف الارتباط والتقنيات المماثلة",
        "paragraphs": [
          "يستخدم الموقع ملفات تعريف ارتباط أساسية وأداء ووظيفية واستهداف. يمكنكم إدارة تفضيلاتكم من خلال إعدادات متصفحكم."
        ]
      },
      {
        "title": "11. النقل الدولي",
        "paragraphs": [
          "تتواجد IS TELECOM في 6 دول أفريقية. قد يتم نقل بياناتكم ومعالجتها في دول غير دول إقامتكم، مع ضمانات مناسبة لحماية بياناتكم."
        ]
      },
      {
        "title": "12. تعديلات السياسة",
        "paragraphs": [
          "تحتفظ IS TELECOM بالحق في تعديل سياسة الخصوصية هذه في أي وقت. سيتم نشر أي تعديل على هذه الصفحة مع تاريخ التحديث."
        ]
      },
      {
        "title": "13. الاتصال",
        "paragraphs": [
          "لأية أسئلة تتعلق بسياسة الخصوصية هذه أو لممارسة حقوقكم، اتصلوا بنا: IS TELECOM — مسؤول حماية البيانات، كوتونو، بنين. الهاتف: +229 01 95 89 27 55. البريد الإلكتروني: contact@is-telecom.co"
        ]
      }
    ]
  }
};